export default __webpack_public_path__ + "img/xoxo.05283fa3.svg";